import template from './assignations.html';
import controller from './assignations.controller';

let assignationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default assignationsComponent;
